import script from "./AdminTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&setup=true&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=6e3cd7d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3cd7d9"]])

export default __exports__